import { render, staticRenderFns } from "./MemberAccessibleVersionCardContent.vue?vue&type=template&id=52ef92f8&"
import script from "./MemberAccessibleVersionCardContent.vue?vue&type=script&lang=ts&"
export * from "./MemberAccessibleVersionCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports